// src/Pages/Landing/JoyrideTurkuLanding.jsx
import React from "react";
import JoyrideKaupunkiLanding from "./JoyrideKaupunkiLanding.jsx";

export default function JoyrideTurkuLanding() {
  return (
    <JoyrideKaupunkiLanding
      city="Turku"
      maakunta="Varsinais-Suomi"
      nearbyAreas={[
        "Kaarina",
        "Raisio",
        "Naantali",
        "Lieto",
        "Paimio",
        "Salo"
      ]}
      cityText="Bilebändi Joyride tekee keikkoja Turussa ja Varsinais-Suomen alueella tapahtuman luonteesta, aikataulusta ja matkasta riippuen. Turku sopii Bilebändi Joyridelle hyvin esimerkiksi häihin, yritysjuhliin, pikkujouluihin, syntymäpäiville ja kesäjuhliin, kun juhliin halutaan energinen livebändi."
      logisticsText="Turun keikoissa kokonaisuus sovitaan aina tapahtumapaikan, aikataulun ja keikan keston mukaan. Bilebändi Joyridellä on oma kuljetus, oma äänentoisto ja valotekniikka, mikä helpottaa juhlan suunnittelua etenkin silloin, kun tapahtumapaikalla ei ole valmista tekniikkaa."
      bookingLink="/#varaa"
    />
  );
}